export default __webpack_public_path__ + "static/media/Gilroy-Bold.a64a9abe.woff";